import { ReducersTypes } from "constants/ReducersTypes";

const initialState = {
  detail: null,
  scoreHistory: [],
  isFetching: false,
  isNotFound: false,
};

const creditCustomerDetail = (state = initialState, action) => {
  switch (action.type) {
    case ReducersTypes.CREDIT_CUSTOMER_DETAIL:
      return { ...state, ...action.payload };
    case ReducersTypes.RESET_CREDIT_CUSTOMER_DETAIL:
      return { ...initialState };
    default:
      return state;
  }
};

export default creditCustomerDetail;
